module.exports = __webpack_public_path__ + "static/media/chrome-icon-512.f84a8428.png";